var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResizeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 48,
    viewBox: "0 0 16 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17361_164955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4H6C8.20914 4 10 5.79086 10 8V40C10 42.2091 8.20914 44 6 44H2V4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 36C6.53043 36 7.03914 36.2107 7.41421 36.5858C7.78929 36.9609 8 37.4696 8 38C8 38.5304 7.78929 39.0391 7.41421 39.4142C7.03914 39.7893 6.53043 40 6 40C5.46957 40 4.96086 39.7893 4.58579 39.4142C4.21071 39.0391 4 38.5304 4 38C4 37.4696 4.21071 36.9609 4.58579 36.5858C4.96086 36.2107 5.46957 36 6 36Z",
    fill: "#51648F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6.53043 8 7.03914 8.21071 7.41421 8.58579C7.78929 8.96086 8 9.46957 8 10C8 10.5304 7.78929 11.0391 7.41421 11.4142C7.03914 11.7893 6.53043 12 6 12C5.46957 12 4.96086 11.7893 4.58579 11.4142C4.21071 11.0391 4 10.5304 4 10C4 9.46957 4.21071 8.96086 4.58579 8.58579C4.96086 8.21071 5.46957 8 6 8Z",
    fill: "#51648F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15C6.53043 15 7.03914 15.2107 7.41421 15.5858C7.78929 15.9609 8 16.4696 8 17C8 17.5304 7.78929 18.0391 7.41421 18.4142C7.03914 18.7893 6.53043 19 6 19C5.46957 19 4.96086 18.7893 4.58579 18.4142C4.21071 18.0391 4 17.5304 4 17C4 16.4696 4.21071 15.9609 4.58579 15.5858C4.96086 15.2107 5.46957 15 6 15Z",
    fill: "#51648F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 22C6.53043 22 7.03914 22.2107 7.41421 22.5858C7.78929 22.9609 8 23.4696 8 24C8 24.5304 7.78929 25.0391 7.41421 25.4142C7.03914 25.7893 6.53043 26 6 26C5.46957 26 4.96086 25.7893 4.58579 25.4142C4.21071 25.0391 4 24.5304 4 24C4 23.4696 4.21071 22.9609 4.58579 22.5858C4.96086 22.2107 5.46957 22 6 22Z",
    fill: "#51648F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 29C6.53043 29 7.03914 29.2107 7.41421 29.5858C7.78929 29.9609 8 30.4696 8 31C8 31.5304 7.78929 32.0391 7.41421 32.4142C7.03914 32.7893 6.53043 33 6 33C5.46957 33 4.96086 32.7893 4.58579 32.4142C4.21071 32.0391 4 31.5304 4 31C4 30.4696 4.21071 29.9609 4.58579 29.5858C4.96086 29.2107 5.46957 29 6 29Z",
    fill: "#51648F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17361_164955",
    x: 0,
    y: 0,
    width: 16,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17361_164955"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17361_164955",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeIcon);
export default __webpack_public_path__ + "static/media/resize-icon.4bddca145ba94f20f806c5302cef5abb.svg";
export { ForwardRef as ReactComponent };